if (!customElements.get('price-range')) {
  class PriceRange extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.minNumberInput = document.getElementById('price-range-number-min');
      this.maxNumberInput = document.getElementById('price-range-number-max');
      this.minSliderInput = document.getElementById('price-range-slider-min');
      this.maxSliderInput = document.getElementById('price-range-slider-max');
      this.minValue = Number(this.minNumberInput.min);
      this.maxValue = Number(this.maxNumberInput.max);
      this.timeout = null;
      this.addEventListener('input', this.handleInput.bind(this));
    }

    /**
     * Handles 'input' events on the price range component.
     * @param {object} evt - Event object.
     */
    handleInput(evt) {
      if (evt.detail !== undefined) {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.updateSliderInputs(evt);
          this.updateNumberInputs();
        }, 500);
      } else {
        this.updateSliderInputs(evt);
        this.updateNumberInputs();
      }
    }

    /**
     * Updates the value of the 'number' type inputs.
     */
    updateNumberInputs() {
      this.minNumberInput.value = this.minSliderInput.value !== this.minNumberInput.min
        ? this.minSliderInput.value : null;

      this.maxNumberInput.value = this.maxSliderInput.value !== this.maxNumberInput.max
        ? this.maxSliderInput.value : null;
    }

    /**
     * Updates the value of the 'range' type inputs.
     * @param {object} evt - Event object.
     */
    updateSliderInputs(evt) {
      const fromNumber = evt.target === this.minNumberInput || evt.target === this.maxNumberInput;
      let minValue = fromNumber ? Number(this.minNumberInput.value || this.minValue) : Number(this.minSliderInput.value);
      let maxValue = fromNumber ? (this.maxNumberInput.value === '' ? this.maxValue : Number(this.maxNumberInput.value)) : Number(this.maxSliderInput.value);
      minValue = Math.min(this.maxValue, Math.max(this.minValue, minValue));
      maxValue = Math.min(this.maxValue, Math.max(this.minValue, maxValue));
      if (minValue > maxValue) {
        if (evt.target === this.minNumberInput || evt.target === this.minSliderInput) maxValue = minValue;
        else minValue = maxValue;
      }
      this.minSliderInput.value = minValue;
      this.maxSliderInput.value = maxValue;
    }
  }

  customElements.define('price-range', PriceRange);
}
